import { PublicUserResponse } from '../../responses/responseTypes';
import type { Nullable } from '../../types';
import { Artist } from '../distribution';
import { User } from './user';

export default class PublicUser implements User {
  id: string;

  email: string;

  firstName: Nullable<string>;

  lastName: Nullable<string>;

  profileImagePath: string;

  artists: Artist[];

  constructor(data: PublicUserResponse) {
    this.id = data.id;
    this.email = data.email;
    this.firstName = data.first_name;
    this.lastName = data.last_name;
    this.profileImagePath = data.profile_image_path;
    this.artists =
      data.artist_names?.map((artist) => ({
        id: artist.id,
        name: artist.name,
      })) ?? [];
  }
}
